<template>
  <el-container style="height: 100%; border: 1px solid #eee">
    <div class="layout-sider" :class="{ isMenuCollapse: isMenuCollapse }">
      <div class="layout-sider-title">
        <div v-if="type === '鹿城'">
          <img src="@/assets/img/lc-logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">鹿城停车岗亭系统</span>
        </div>
        <div v-else-if="type === '龙港'">
          <img src="@/assets/img/lg-logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">龙港交发岗亭系统</span>
        </div>
        <div v-else-if="type === '停简单'">
          <img src="@/assets/img/wz-logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">停简单岗亭系统</span>
        </div>
        <div v-else-if="type === '数发'">
          <img src="@/assets/img/sf-logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">数发停车岗亭系统</span>
        </div>
        <div v-else-if="type === '上饶'">
          <img src="@/assets/img/sr-logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">上饶畅通岗亭系统</span>
        </div>
        <div v-else-if="type === '武汉'">
          <img src="@/assets/img/wh-logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">武汉城停岗亭系统</span>
        </div>
        <div v-else-if="type === '萍乡'">
          <img src="@/assets/img/px-logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">萍乡停车岗亭系统</span>
        </div>
        <div v-else-if="type === '逐一'">
          <img src="@/assets/img/zy-logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">智慧停车岗亭系统</span>
        </div>
        <div v-else-if="type === '车都'">
          <img src="@/assets/img/cd-logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">车都停车岗亭系统</span>
        </div>
        <div v-else-if="type === '温州'">
          <img src="@/assets/img/logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">智慧停车系统岗亭端</span>
        </div>
        <div v-else>
          <img src="@/assets/img/logo.png" style="width: 24px; margin-right: 5px;"/>
          <span v-if="!isMenuCollapse">智慧停车岗亭系统</span>
        </div>
        <span @click="$store.dispatch('ToggleMenuCollapse')" class="spanBtn" v-if="!isSentryBoxManager">
          <img src="@/assets/img/icon12.png" style="width: 30px;"  v-if="isMenuCollapse"/>
          <img src="@/assets/img/icon11.png" style="width: 30px;"  v-else/>
        </span>
      </div>
      <div class="layout-sider-search" :class="{isMenuCollapse: isMenuCollapse}" v-if="!isSentryBoxManager">
        <el-autocomplete
          popper-class="my-autocomplete"
          v-model="state"
          :fetch-suggestions="querySearch"
          :placeholder="isMenuCollapse ? '' : '搜索车场'"
          @select="handleSelect">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="handleCollapse"></i>
          <template slot-scope="{ item }">
            <div class="name">{{ item.Name }}</div>
          </template>
        </el-autocomplete>
      </div>
      <el-aside
        :width="isMenuCollapse ? '60px' : '220px'"
        class="layout-sider-menu"
        :style="{ height: (height - 100) + 'px' }"
      >
        <tree-menu @changeRouter="refreshRouter" :treeSentryId="sentryId"  v-if="!isSentryBoxManager"/>
        <tree-tabs v-else></tree-tabs>
      </el-aside>
    </div>
    <el-container>
      <el-header
        class="layout-header"
        style="text-align: right; font-size: 12px"
        :style="{justifyContent: isChoose ? 'space-between':'flex-end'}"
      >
        <header-button-group v-if="isChoose"></header-button-group>
        <div class="header-title"><img src="@/assets/img/img08.png" style="width: 22px; margin-right: 2px;"/>{{$route.params.GateName}}</div>
        <div class="layout-header-right">
          <now-time />
          <div class="header-right">
            <tenant-select class="header-item" />
            <user class="header-item" />
          </div>
          <header-item
            @click="toggleFullScreen"
            class="header-item"
            :icon="'el-icon-full-screen'"
            title=""
          />
        </div>
      </el-header>
      <el-main class="layout-main" :style="{ height: mainHeight + 'px' }">
        <router-view v-show="isRefresh && isChoose" />
        <img
          v-if="!isChoose"
          class="nodata"
          src="@/assets/img/nodata02@2x.png"
          alt=""
        />
      </el-main>
    </el-container>
    <login-select ref="loginSelect" @selectChange="selectChange"></login-select>
  </el-container>
</template>
<script>
import headerItem from "./components/headerItem";
import tenantSelect from "./components/tenantSelect";
import User from "./components/user";
import { setWindowFullScreen } from "@/utils/tool";
import treeMenu from "./components/treeMenu";
import headerButtonGroup from "./components/realtimeBtnList";
import nowTime from "./components/nowTime";
import loginSelect from "@/components/LoginSelect";
import { getRoleCode, setLoginSentryId, getLoginSentryId, getIsSentryBoxTabs } from "@/utils/service";
import { refreshSentryCashier, listTenantUserSentryBox } from "@/api/module/tenant";
import { distinguishTitle } from "@/utils/index";
import treeTabs from "./components/treeTabs";

export default {
  data() {
    return {
      height: 0,
      mainHeight: 0,
      data: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      isFull: true,
      isRefresh: false,
      isChoose: false,
      sentryId: undefined,
      restaurants: [],
      state: '',
      type: '',
    };
  },
  watch: {
    $route: function () {
       this.checkRouter();
    },
    userId: 'checkRole',
    isReLogin: 'checkRole',
    loadAll(v) {
      this.restaurants = v;
    },
  },
  computed: {
    isMenuCollapse: function () {
      return this.$store.state.layout.isMenuCollapse;
    },
    userId: function () {
      return this.$store.state.user.userInfo.Id
    },
    isReLogin: function () {
      return this.$store.state.user.isReLogin
    },
    loadAll: function () {
      return this.$store.state.layout.searchArr
    },
    isSentryBoxManager : function () {
      return this.$store.state.layout.isSentryBoxTabs ? this.$store.state.layout.isSentryBoxTabs === 'true' : getIsSentryBoxTabs() === 'true';
    }
  },
  mounted() {
    this.calcHeight();
    let _this = this;
    window.onresize = function () {
      _this.calcHeight();
    };
    // console.log(this.isChoose);
    if (this.isChoose) {
      this.refreshRouter();
    }
    this.checkRole();
    this.sentryId = getLoginSentryId() ? Number(getLoginSentryId()) : undefined;
  },
  created() {
    this.type = distinguishTitle();
    this.checkRouter();
  },
  components: { headerItem, tenantSelect, User, treeMenu, headerButtonGroup, nowTime, loginSelect, treeTabs },
  methods: {
    checkRouter() {
      let params = this.$route.params;
      if (Number(params.ParkLotId)) {
        this.$store.dispatch("SetParkLotId", Number(params.ParkLotId));
        this.$store.dispatch("SetGateId", Number(params.GateId));
        this.isChoose = true;
        if (this.isSentryBoxManager) this.isRefresh = true;
        // this.isRefresh=true
      } else {
        this.isChoose = false;
      }
    },
    // 高度计算
    calcHeight() {
      let wHeight = window.innerHeight;
      this.height = wHeight - 60;
      this.mainHeight = wHeight - 60;
    },
    // 全屏功能
    toggleFullScreen() {
      this.isFull = setWindowFullScreen();
    },
    refreshRouter() {
      this.isChoose = true;
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    async checkRole() {
      this.sentryId = undefined;
      let res = await listTenantUserSentryBox();
      if (res.state === "success") {
        if (res.data.length === 1) {
          this.selectChange(res.data[0].Id);
        } else {
          this.$refs.loginSelect.dialogVisible = getRoleCode() === 'sentryBox' && !this.isSentryBoxManager && (getLoginSentryId() === null || getLoginSentryId() === '') ;
          this.$refs.loginSelect.resObj.state = res.state;
          this.$refs.loginSelect.options = res.data;
        }
      } else {
        this.$refs.loginSelect.dialogVisible = getRoleCode() === 'sentryBox' && !this.isSentryBoxManager && (getLoginSentryId() === null || getLoginSentryId() === '') ;
        this.$refs.loginSelect.resObj.state = res.state;
        this.$refs.loginSelect.options = [];
        this.$refs.loginSelect.resObj.message = res.message;
      }
    },
    selectChange(sentryValue) {
      this.sentryId = sentryValue;
      setLoginSentryId(this.sentryId);
      if(this.sentryId !== '') refreshSentryCashier({sentryId: this.sentryId});
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },
    handleSelect(item) {
      // console.log('handleSelect', item);
      // this.$router.push(`/home/tenant/${this.data[0].Id}/${this.data[0].Name}/${this.data[0].children[0].Id}/${this.data[0].children[0].Name}`);
      this.$router.push(`/home/tenant/${item.Id}/${item.Name}/${item.Node[0].Id}/${item.Node[0].Name}`);
      this.$store.dispatch("SETAutoCompleteSelect", `/home/tenant/${item.Id}/${item.Name}/${item.Node[0].Id}/${item.Node[0].Name}`);
    },
    handleCollapse() {
      if (this.isMenuCollapse) this.$store.dispatch('ToggleMenuCollapse');
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
<style lang="scss">
  $primary: #1C1C1E ;
  $primary: #ffffff ;
  .el-header {
    background-color: #b3c0d1;
    color: #333;
    line-height: 60px;
  }

  .el-aside {
    color: #fff;
  }
  .layout-sider {
    background: $primary;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100vh;
    color: white;
    align-items: center;

    // overflow: hidden;
    width: 220px;
    &.isMenuCollapse{
      width: 60px;
    }
    & .layout-sider-title {
      background: $primary;
      font-size: 16px;
      width: 100%;
      /*padding: 20px 0;*/
      // position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      color: #333;
      .spanBtn{
        margin-top: 11px;
        margin-bottom: 20px;
        display: block;
      }
      >div{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px 0;
      }
    }
    & .layout-sider-menu {
      flex-grow: 1;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #535353;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
      }
    }
  }
  .layout-header {
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: inherit;
    margin-left: 20px;
    .layout-header-right{
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    & .header-right{
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    & .header-item {
      margin-left: 20px;
    }
  }
  .layout-main {
    background: #f8f8f8;
    position: relative;
  }
  .layout-sider-tree {
    background: $primary;
    color: #ffff;
    & .el-tree-node__content:hover {
      background: #fff;
      color: $primary;
    }
  }
  .nodata {
    width: 580px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .layout-sider-search{
    padding: 0 20px;
  }
  .layout-sider-search.isMenuCollapse{
    .el-input__inner{
      height: 40px;
      width: 40px;
      padding: 0;
    }
    .el-input__suffix{
      width: 30px;
    }
  }
  .header-title{
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    display: flex;
    align-items: center;
  }
  .tree-tabs{
    .el-tabs__header.is-left{
      float: right;
    }
    .el-tabs__content{
      width: 0;
    }
  }
</style>
